/**
 * Hawai Lungi header interactions: offcanvas mobile menu open/close and
 * highlighting the active mobile bottom-nav item for the current page.
 */
(function () {
  function initMobileMenu() {
    var openBtn = document.querySelector('.js-hl-open-menu');
    var closeBtn = document.querySelector('.js-hl-close-menu');
    var overlay = document.querySelector('.hl-mobile-menu-overlay');
    var menu = document.querySelector('.hl-mobile-menu');
    if (!openBtn || !menu || !overlay) return;

    var open = function () {
      overlay.classList.add('hl-open');
      menu.classList.add('hl-open');
      openBtn.setAttribute('aria-expanded', 'true');
    };
    var close = function () {
      overlay.classList.remove('hl-open');
      menu.classList.remove('hl-open');
      openBtn.setAttribute('aria-expanded', 'false');
    };

    openBtn.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);
    overlay.addEventListener('click', close);
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') close();
    });
  }

  function markActiveBottomNav() {
    var items = document.querySelectorAll('.hl-mobile-bottom-nav a[data-hl-page]');
    items.forEach(function (link) {
      if (link.dataset.hlPage === window.location.pathname) {
        link.classList.add('hl-active');
      }
    });
  }

  function tagBottomNavPadding() {
    if (document.querySelector('.hl-mobile-bottom-nav')) {
      document.body.classList.add('hl-has-bottom-nav');
    }
  }

  function initWishlistToggles() {
    document.addEventListener('click', function (event) {
      var btn = event.target.closest('.js-hl-wishlist');
      if (!btn) return;
      btn.classList.toggle('hl-active');
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initMobileMenu();
    markActiveBottomNav();
    tagBottomNavPadding();
    initWishlistToggles();
  });
})();
